import { getContext } from 'configs/context';
import { useRef, useState } from 'react';
import useMount from 'hooks/common/useMount';

const useOpen = (callback: () => void) => {
  const callbackRef = useRef(callback);
  callbackRef.current = callback;

  const [state, setState] = useState(false);

  useMount(() => {
    const removeOnOpen = getContext().handlers.onOpen(() => {
      setState(true);
      callbackRef.current();
    });

    return () => {
      removeOnOpen();
    };
  });

  return state;
};

export default useOpen;
